<template>
    <baseMessageField ref="baseMessageFieldComponent" />
    <RouterView />
</template>

<style></style>

<script setup>
    import { RouterView } from 'vue-router';
    import { provide, ref } from 'vue';
    import baseMessageField from '@/commonProject/parts/BaseMessageField.vue';
    const baseMessageFieldComponent = ref();

    // メッセージダイアログ表示処理呼び出し
    function messageDialog(type, message) {
        baseMessageFieldComponent.value.show(type, message);
    }

    // messageDialogを登録。各種画面からinjectで利用する
    provide('messageDialogKey', {
        messageDialog,
    });
</script>
